import { Component, EventEmitter, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { CustomValidators } from "../../../_shared/custom-validator";

@Component({
  selector: "app-add-text",
  templateUrl: "./add-text.component.html",
  styleUrls: ["./add-text.component.scss"],
  standalone: false
})
export class AddTextComponent {
  public textControl = new FormControl<string>("", [CustomValidators.requiredTrimmed()]);
  @Output() addEmitter = new EventEmitter();

  constructor() {}

  add() {
    if (this.textControl.invalid) {
      return;
    }
    this.addEmitter.emit(this.textControl.value.trim());
  }
}
